import Vue from 'vue';
import {
  Button, Tabs, Table, TableColumn, Progress, Popover, Input, Select, Option,
  Row, Col, Message, Card, Dialog, Carousel, CarouselItem, Dropdown, DropdownMenu,
  DropdownItem, Tooltip,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import VueClipboard from 'vue-clipboard2';

locale.use(lang);
Vue.prototype.$message = Message;

Vue.use(Button);
Vue.use(Tabs);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress);
Vue.use(Popover);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Dialog);
Vue.use(VueClipboard);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tooltip);
